// third-party
import { combineReducers } from '@reduxjs/toolkit';

// project import
import menu from './menu';
import snackbar from './snackbar';
import auth from './auth';
import zignaAi from './zignaAi';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import dataAudit from './dataAudit';
import ancillaryAndFacility from './ancillaryAndFacility';

// ==============================|| COMBINE REDUCERS ||============================== //

const authPersistConfig = {
  key: 'auth',
  storage: storage
};
const reducers = combineReducers({
  auth: persistReducer(authPersistConfig, auth),
  menu,
  snackbar,
  zignaAi,
  dataAudit,
  ancillaryAndFacility
});

export default reducers;
